(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6985],{

/***/ 47046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MetaTagsComp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59830);





const MetaTagsComp = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const currentUrl = "https://www.studies-overseas.com" + (router.asPath || "");
    const { metaTitle , metaDescription , src , keywords , robotsMeta , ogimage , twitterimage , isCustomSchema , schemaJson , jotforms , canonicalUrl , isBlogPage  } = props;
    const structuredJSON = isCustomSchema && schemaJson ? schemaJson : _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultSchema */ .R4;
    const removeQueryParameters = (url)=>{
        const currentUrl = url;
        const queryIndex = currentUrl.indexOf("?");
        return queryIndex !== -1 ? currentUrl.slice(0, queryIndex) : currentUrl;
    };
    const cleanCanonicalUrl = canonicalUrl ? removeQueryParameters(canonicalUrl) : removeQueryParameters(currentUrl);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: metaTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: metaDescription
                }),
                keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "keywords",
                    content: keywords
                }),
                robotsMeta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: robotsMeta
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:url",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:type",
                    content: "Organization"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: ogimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:site_name",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "canonical",
                    href: cleanCanonicalUrl || canonicalUrl
                }),
                src && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    src: src
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary_large_image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:site",
                    content: "@KCOverseasEdu"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:creator",
                    content: "@KCOverseasEdu"
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:image",
                    content: twitterimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                structuredJSON && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    className: "structured-data-list",
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(structuredJSON)
                    }
                })
            ]
        })
    });
};


/***/ }),

/***/ 20052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Dropdown_Dropdown; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/UI/Dropdown/Dropdown.module.scss
var Dropdown_module = __webpack_require__(92681);
var Dropdown_module_default = /*#__PURE__*/__webpack_require__.n(Dropdown_module);
// EXTERNAL MODULE: ./components/UI/Icons/Chevron.tsx
var Chevron = __webpack_require__(72767);
// EXTERNAL MODULE: ./components/UI/Icons/CrossIcon.tsx
var CrossIcon = __webpack_require__(30535);
// EXTERNAL MODULE: ./components/UI/Icons/TickMark.tsx
var TickMark = __webpack_require__(81945);
;// CONCATENATED MODULE: ./components/UI/Icons/SearchIcon.tsx


const SearchIcon = ({ width =16 , height =16 , color ="#226CF5"  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.5 17.5L13.875 13.875",
                stroke: "#226CF5",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_SearchIcon = (SearchIcon);

;// CONCATENATED MODULE: ./components/UI/Dropdown/Dropdown.tsx







const Dropdown = ({ options , value =null , onChange , onClear , showClear =false , placeholder ="Select" , disabled =false , className ="" , multiple =false , selectedValues =[] , onSelectionChange , searchable =false , searchPlaceholder ="Search"  })=>{
    const { 0: isOpen , 1: setIsOpen  } = (0,react.useState)(false);
    const { 0: searchTerm , 1: setSearchTerm  } = (0,react.useState)("");
    const wrapperRef = (0,react.useRef)(null);
    const searchInputRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        if (!isOpen) return;
        const handleClickOutside = (event)=>{
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>document.removeEventListener("mousedown", handleClickOutside);
    }, [
        isOpen
    ]);
    (0,react.useEffect)(()=>{
        if (isOpen && searchable) {
            searchInputRef.current?.focus();
        } else {
            setSearchTerm("");
        }
    }, [
        isOpen,
        searchable
    ]);
    const toggleOpen = ()=>{
        if (!disabled) setIsOpen((prev)=>!prev);
    };
    const handleSelect = (option)=>{
        onChange?.(option);
        setIsOpen(false);
    };
    const isOptionSelected = (option)=>selectedValues.some((selected)=>selected.value === option.value);
    const handleToggle = (option)=>{
        const next = isOptionSelected(option) ? selectedValues.filter((selected)=>selected.value !== option.value) : [
            ...selectedValues,
            option
        ];
        onSelectionChange?.(next);
    };
    const handleRemoveChip = (event, option)=>{
        event.stopPropagation();
        onSelectionChange?.(selectedValues.filter((selected)=>selected.value !== option.value));
    };
    const handleClear = (event)=>{
        event.stopPropagation();
        onClear?.();
        setIsOpen(false);
    };
    const canClear = showClear && !!value && !disabled;
    const visibleOptions = options.filter((option)=>option.value !== "" && option.value !== undefined && option.value !== null);
    const filteredOptions = searchable && searchTerm ? visibleOptions.filter((option)=>option.label.toLowerCase().includes(searchTerm.toLowerCase())) : visibleOptions;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: wrapperRef,
        className: `${(Dropdown_module_default()).dropdown} ${className}`,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: (Dropdown_module_default())["dropdown-trigger"],
                onClick: toggleOpen,
                disabled: disabled,
                "aria-haspopup": "listbox",
                "aria-expanded": isOpen,
                children: [
                    multiple ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: selectedValues.length ? (Dropdown_module_default())["dropdown-chips"] : (Dropdown_module_default())["dropdown-placeholder"],
                        children: selectedValues.length ? selectedValues.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (Dropdown_module_default())["dropdown-chip"],
                                children: [
                                    option.label,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (Dropdown_module_default())["dropdown-chip-remove"],
                                        role: "button",
                                        "aria-label": `Remove ${option.label}`,
                                        onClick: (event)=>handleRemoveChip(event, option),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossIcon/* default */.Z, {
                                            width: 10,
                                            height: 10,
                                            color: "#64647A"
                                        })
                                    })
                                ]
                            }, option.value)) : placeholder
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: value ? (Dropdown_module_default())["dropdown-value"] : (Dropdown_module_default())["dropdown-placeholder"],
                        children: value?.label ?? placeholder
                    }),
                    !multiple && canClear ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Dropdown_module_default())["dropdown-clear"],
                        role: "button",
                        "aria-label": "Clear selection",
                        onClick: handleClear,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossIcon/* default */.Z, {
                            width: 12,
                            height: 12,
                            color: "#64647A"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: `${(Dropdown_module_default())["dropdown-chevron"]} ${isOpen ? (Dropdown_module_default())["dropdown-chevron--open"] : ""}`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                            width: 12,
                            height: 12,
                            color: "#64647A"
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Dropdown_module_default())["dropdown-menu"],
                children: [
                    searchable && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Dropdown_module_default())["dropdown-search-wrapper"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (Dropdown_module_default())["dropdown-search-icon"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_SearchIcon, {
                                    width: 16,
                                    height: 16,
                                    color: "#64647A"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                ref: searchInputRef,
                                type: "text",
                                className: (Dropdown_module_default())["dropdown-search"],
                                placeholder: searchPlaceholder,
                                value: searchTerm,
                                onClick: (event)=>event.stopPropagation(),
                                onChange: (event)=>setSearchTerm(event.target.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (Dropdown_module_default())["dropdown-options"],
                        role: "listbox",
                        "aria-multiselectable": multiple,
                        children: filteredOptions.length > 0 ? filteredOptions.map((option, index)=>{
                            const selected = multiple ? isOptionSelected(option) : value?.value === option.value;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                role: "option",
                                "aria-selected": selected,
                                className: `${(Dropdown_module_default())["dropdown-option"]} ${selected && !multiple ? (Dropdown_module_default())["dropdown-option--selected"] : ""} ${multiple ? (Dropdown_module_default())["dropdown-option--checkable"] : ""}`,
                                onClick: ()=>multiple ? handleToggle(option) : handleSelect(option),
                                children: [
                                    multiple && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: `${(Dropdown_module_default())["dropdown-checkbox"]} ${selected ? (Dropdown_module_default())["dropdown-checkbox--checked"] : ""}`,
                                        children: selected && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            width: "12",
                                            height: "12",
                                            viewBox: "0 0 12 12",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M10 3L4.5 8.5L2 6",
                                                stroke: "#fff",
                                                strokeWidth: "1.8",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        })
                                    }),
                                    option.label,
                                    " ",
                                    !multiple && selected && /*#__PURE__*/ (0,jsx_runtime.jsx)(TickMark/* default */.Z, {
                                        color: "#226CF5"
                                    })
                                ]
                            }, `${option.value}-${index}`);
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (Dropdown_module_default())["dropdown-empty"],
                            children: "No Items"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Dropdown_Dropdown = (Dropdown);


/***/ }),

/***/ 72767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const Chevron = ({ width =13 , height =21 , color ="#0B0C2D"  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 13 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1.5 19L11.5 10.6667L1.5 1.5",
            stroke: color,
            "stroke-width": "3",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Chevron);


/***/ }),

/***/ 30535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const CrossIcon = ({ width =20 , height =20 , color ="#868697"  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M13 0.999939L1 12.9999M1 0.999939L13 12.9999",
            stroke: color,
            strokeWidth: "1.99991",
            strokeLinecap: "round"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CrossIcon);


/***/ }),

/***/ 81945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const TickMark = ({ width =16 , height =16 , color ="#ffffff"  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 17 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1.5 7.5L5.7 11.5L15.5 1.5",
            stroke: color,
            "stroke-width": "3",
            "stroke-linecap": "round"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TickMark);


/***/ }),

/***/ 14523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
// hooks/useIsMobile.ts

const useIsMobile = (breakpoint = 768)=>{
    const { 0: isMobile , 1: setIsMobile  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);
        const handleChange = (e)=>{
            setIsMobile(e.matches);
        };
        // Set initial value
        setIsMobile(mediaQuery.matches);
        // Listen for changes
        mediaQuery.addEventListener("change", handleChange);
        return ()=>{
            mediaQuery.removeEventListener("change", handleChange);
        };
    }, [
        breakpoint
    ]);
    return isMobile;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsMobile);


/***/ }),

/***/ 92681:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"Dropdown_hide-scrollbar___S1Ub","dropdown":"Dropdown_dropdown__R041p","dropdown-trigger":"Dropdown_dropdown-trigger__7b85a","dropdown-placeholder":"Dropdown_dropdown-placeholder__jzrW7","dropdown-value":"Dropdown_dropdown-value__2_ihv","dropdown-clear":"Dropdown_dropdown-clear__wKD2v","dropdown-chevron":"Dropdown_dropdown-chevron___9XVo","dropdown-chevron--open":"Dropdown_dropdown-chevron--open__TNJ1m","dropdown-menu":"Dropdown_dropdown-menu__09Nkd","dropdown-search-wrapper":"Dropdown_dropdown-search-wrapper__zk_F4","dropdown-search-icon":"Dropdown_dropdown-search-icon__C23UZ","dropdown-search":"Dropdown_dropdown-search__RwTXL","dropdown-options":"Dropdown_dropdown-options__LE6iE","dropdown-option":"Dropdown_dropdown-option__REJgQ","dropdown-option--selected":"Dropdown_dropdown-option--selected__tUc_m","dropdown-empty":"Dropdown_dropdown-empty__pl7ye","dropdown-chips":"Dropdown_dropdown-chips__MJc1Q","dropdown-chip":"Dropdown_dropdown-chip__Nfud0","dropdown-chip-remove":"Dropdown_dropdown-chip-remove__LaLJs","dropdown-option--checkable":"Dropdown_dropdown-option--checkable__xTw9T","dropdown-checkbox":"Dropdown_dropdown-checkbox__xMRKU","dropdown-checkbox--checked":"Dropdown_dropdown-checkbox--checked__KIYPE"};

/***/ }),

/***/ 26699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/Anchor.js + 10 modules
var Anchor = __webpack_require__(23646);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/BreadcrumbItem.js





const defaultProps = {
  active: false,
  linkProps: {}
};
const BreadcrumbItem = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  active,
  children,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'li',
  linkAs: LinkComponent = Anchor/* default */.Z,
  linkProps,
  href,
  title,
  target,
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'breadcrumb-item');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(prefix, className, {
      active
    }),
    "aria-current": active ? 'page' : undefined,
    children: active ? children : /*#__PURE__*/(0,jsx_runtime.jsx)(LinkComponent, { ...linkProps,
      href: href,
      title: title,
      target: target,
      children: children
    })
  });
});
BreadcrumbItem.displayName = 'BreadcrumbItem';
BreadcrumbItem.defaultProps = defaultProps;
/* harmony default export */ var esm_BreadcrumbItem = (BreadcrumbItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js





const Breadcrumb_defaultProps = {
  label: 'breadcrumb',
  listProps: {}
};
const Breadcrumb = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  listProps,
  children,
  label,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'nav',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'breadcrumb');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    "aria-label": label,
    className: className,
    ref: ref,
    ...props,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("ol", { ...listProps,
      className: classnames_default()(prefix, listProps == null ? void 0 : listProps.className),
      children: children
    })
  });
});
Breadcrumb.displayName = 'Breadcrumb';
Breadcrumb.defaultProps = Breadcrumb_defaultProps;
/* harmony default export */ var esm_Breadcrumb = (Object.assign(Breadcrumb, {
  Item: esm_BreadcrumbItem
}));

/***/ })

}]);